<template>
  <div class="edit-style-select-color">
    <span class="common-label">{{ labelText }}</span>
    <div
      class="color-picker-box"
      @click="clickColorForm"
    >
      <div class="color-picker-label">
        <div class="active-color" :style="activeColorStyle"></div>
        {{ displayColorText }}
      </div>
    </div>
    <color-picker
      v-on-clickaway="colorPickerAway"
      v-if="showColorPicker"
      :selectColor="color"
      :transparent="true"
      @updateStyles="updateStyles($event)"
      :class="target"
    />
  </div>
</template>

<script>
import ColorPicker from '@/components/Content/Palette/CommonLayouts/Colorpicker'
import { mixin as onClickAway } from 'vue-clickaway'

export default {
  props: [
    'type', // 変更したい箇所：[ selector ] or [ section ] or [ part ] or [ partsContainer ]
    'target', // 変更したいスタイル：[ color ] or [ background ] or [ outer-background ]
    'selector', // 変更したい箇所が [ selector ] の場合のみ：対象の要素 [ h1 〜 h4 ]
    'value' // カラーコード
  ],
  mixins: [
    onClickAway
  ],
  components: {
    ColorPicker,
  },
  data () {
    return {
      color: null,
      labelText: null,
    }
  },
  computed: {
    showColorPicker () {
      let returnValue = null
      if (this.type === 'selector') {
        // Pageから表示した場合
        returnValue = this.currentColorPicker.selector === this.selector
      } else if (this.type === 'section' || this.type === 'part' || this.type === 'partsContainer') {
        // 各セクション or パーツから表示した場合
        returnValue = this.currentColorPicker.prop === this.target
      }
      return returnValue
    },
    // 画面に表示する色名：未設定 または 透明が設定されていたら「未設定」表示
    displayColorText () {
      return this.value && this.value !== 'transparent' ? this.value : '未設定'
    },
    currentColorPicker () {
      return this.$store.getters.getStatusColorPicker
    },
    // カラーチップ
    activeColorStyle () {
      const activeColorStyle = {
        'background': this.value && this.value !== 'transparent' ? this.value : '#FFFFFF'
      }
      // 白背景の場合、見えなくなってしまうので枠線を付ける
      activeColorStyle['border'] = activeColorStyle.background === '#FFFFFF' ? '1px solid #c6c6c6' : `1px solid ${this.value}`
      return activeColorStyle
    }
  },
  methods: {
    initColor () {
      this.color = this.value || null
    },
    initLabelText () {
      const targetText = this.target.replace(/inner_/, '')
      if (targetText === 'background') {
        this.labelText = '背景色'
      } else if (targetText === 'color' || targetText === 'outer-background') {
        this.labelText = '色'
      }
    },
    clickColorForm () {
      this.updateStatusColorPicker('pane', 'palette')
      if (this.type === 'selector') {
        this.updateStatusColorPicker('selector', this.selector)
      } else if (this.type === 'section' || this.type === 'part' || this.type === 'partsContainer') {
        this.updateStatusColorPicker('prop', this.target)
      }
    },
    colorPickerAway () {
      if (this.type === 'selector' && this.currentColorPicker.selector === this.selector) {
        this.updateStatusColorPicker('pane', null)
        this.updateStatusColorPicker('selector', null)
      } else if ((this.type === 'section' || this.type === 'part' || this.type === 'partsContainer') && this.currentColorPicker.prop === this.target) {
        this.updateStatusColorPicker('pane', null)
        this.updateStatusColorPicker('prop', null)
      }
    },
    updateStyles (value) {
      const styles = [
        { prop: this.target, value: value }
      ]
      this.$emit('updateStyles', styles)
    },
    // カラーピッカーの表示ステータス更新
    updateStatusColorPicker (prop, value) {
      this.$store.commit('updateStatusColorPicker', {
        prop: prop,
        value: value
      })
    },
  },
  mounted () {
    this.initColor()
    this.initLabelText()
  },
  watch: {
    value () {
      this.initColor()
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-style-select-color {
  position: relative;
  label {
    font-size: 12px;
    color: #fff;
    position: absolute;
    top: -30px;
    z-index: 10;
    background: rgba(72, 72, 72, 0.9);
    padding: 1px 8px;
    border-radius: 5px;
    &::before {
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      border-width: 8px 5px 0 5px;
      border-color: rgba(72, 72, 72, 0.9) transparent transparent transparent;
      position: absolute;
      top: 100%;
      left: 50%;
      z-index: 10;
      transform: translateX(-50%);
    }
  }
  .color-picker-box {
    display: block;
    width: 105px;
    height: 39px;
    box-sizing: border-box;
    padding: 8px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: $commonFontColor;
    border: 0.5px solid #c6c6c6;
    border-radius: 4px;
    background: #ffffff;
    .color-picker-label {
      display: flex;
      align-items: center;
      .active-color {
        width: 12px;
        height: 12px;
        margin-right: 4px;
        border-radius: 2px;
      }
    }
  }
}
</style>

<style lang="scss">
.edit-style-select-color {
  .window {
    top: 58px;
    right: 0;
  }
  .background, .outer-background {
    .window {
      top: 58px;
      left: 0;
    }
  }
}
</style>
